<script lang="ts">
	let {
		size = 48,
		color = 'blue-600',
		class: className = ''
	}: {
		size?: number;
		color?: string;
		class?: string;
	} = $props();
</script>

<div class="flex justify-center py-12 {className}">
	<div
		class="animate-spin rounded-full border-b-2 border-{color}"
		style="width: {size}px; height: {size}px;"
	></div>
</div>
